import React, { useEffect, useState } from 'react'
import {Box, Grid, GridItem, Heading, IconButton, Image, Input, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr} from '@chakra-ui/react'
import { Document, Page } from 'react-pdf';
import NavBar from '../../../elements/NavBar'
import Loader from '../../../elements/loader'
import { connect, useSelector } from 'react-redux'
import { ActionCreators } from '../../../../redux/actions'
import { bindActionCreators } from 'redux'
import Pagination from '../../../elements/Pagination';
import CustomButton from '../../../elements/customButton';
import NoData from '../../../elements/NoData';
import SendSMSDialog from '../components/SendSMSDialog';

const RecoveryDashboard = (props) => {

    const adminState = useSelector((state) => state.adminState)
    const [currentPage, setCurrentPage] = useState(0)
    const [filterData, setFilterData] = useState([])
    const [openSendSMS, setOpenSendSMS] = useState(false)
    const [inputValues, setInputValues] = useState({});
    const userDataProfile = adminState?.getUserByToken?.data?.data
    const PER_PAGE = 10;
    const offset = currentPage * PER_PAGE;
    const pageCount = Math.ceil(filterData?.length / PER_PAGE);

    useEffect(() => {
        props.actions.getUserByTokenAction()
    }, [])

    const handleSearch = (e) => {
        const {value} = e.target
        // if (value !== '') {
        //   const result = newBorrowers.filter((item) => {
        //     return item?.mobile?.toLowerCase().includes(value.toLowerCase()) || item?.first_name?.toLowerCase().includes(value.toLowerCase())
        //   })
        //   setFilterData(result)
        // } else {
        //   setFilterData(newBorrowers)
        // }
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setInputValues({...inputValues, [name]: value})
    }

    const handleOpenSendSMS = () => {
        setOpenSendSMS(true)
    }

    const handleCloseSendSMS = () => {
        setOpenSendSMS(false)
    }

    const handlePageClick = ({ selected: selectedPage }) => {
        setCurrentPage(selectedPage);
    }

  return (
    <>
        {(adminState?.getUserByToken?.loading) &&
            <div>
                <Loader />
            </div>
        }
        <Box className='dashboard_box bg_shadow'>
            <Grid className="main_grid_container align-items-center">
                <GridItem colSpan={8}>
                    <Heading as="h2" className='font-poppins page_heading'>Recovery List</Heading>
                </GridItem>
                <GridItem colSpan={4}>
                    <NavBar data={userDataProfile} isAdmin />
                </GridItem>
            </Grid>
            <Box mt={8}>
                <Box className='search_box'>
                    <Input type="text" size="md" name="search" placeholder="Search" onChange={handleSearch}
                        className="input_box font-poppins"
                    />
                </Box>
                <>
                    <Box mt={2} className='custom_table_wrapper'>
                        <TableContainer>
                            <Table variant="simple">
                                <Thead>
                                    <Tr>
                                        <Th>S.No.</Th>
                                        <Th>Loan Number</Th>
                                        <Th>Loan Amount</Th>
                                        <Th>Name</Th>
                                        <Th>Phone Number</Th>
                                        <Th>Email</Th>
                                        <Th>Full Address</Th>
                                        <Th>Total Outstanding Amt</Th>
                                        <Th>Total Recovery Amt</Th>
                                        <Th>Send SMS</Th>
                                        <Th>Pay Now</Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    <Tr>
                                        <Td>
                                            <Text className="font-poppins table_text">1</Text>
                                        </Td>
                                        <Td>
                                            <Text className="font-poppins table_text">3337439797</Text>
                                        </Td>
                                        <Td>
                                            <Text className="font-poppins table_text">₹10000</Text>
                                        </Td>
                                        <Td>
                                            <Text className="font-poppins table_text">Divyansh Garg</Text>
                                        </Td>
                                        <Td>
                                            <Text className="font-poppins table_text">0987654321</Text>
                                        </Td>
                                        <Td>
                                            <Text className="font-poppins table_text">admin@admin.com</Text>
                                        </Td>
                                        <Td>
                                            <Text className="font-poppins table_text">admin@admin.com</Text>
                                        </Td>
                                        <Td>
                                            <Text className="font-poppins table_text">₹10000</Text>
                                        </Td>
                                        <Td>
                                            <Text className="font-poppins table_text">₹10000</Text>
                                        </Td>
                                        <Td>
                                            <Box className='actions_td'>
                                                <CustomButton size="md" type="submit" title="Send SMS" className="btn_table_green font-poppins" onClick={handleOpenSendSMS} />
                                            </Box>
                                        </Td>
                                        <Td>
                                            <Box className='actions_td'>
                                                <CustomButton size="md" type="submit" title="Pay EMI" className="btn_table_theme font-poppins" />
                                            </Box>
                                        </Td>
                                    </Tr>
                                </Tbody>
                            </Table>
                        </TableContainer>
                        <Pagination pageCount={pageCount} handlePageClick={handlePageClick} />
                    </Box>
                </>
            </Box>
        </Box>
        <SendSMSDialog
            openSendSMS={openSendSMS}
            inputValues={inputValues}
            handleCloseSendSMS={handleCloseSendSMS}
            handleChange={handleChange}
        />
    </>
  )
}
const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(ActionCreators, dispatch),
  })
  
export default connect(null, mapDispatchToProps)(RecoveryDashboard)
